import { IMilestone } from "@mctypes/global.types";
import { ColDef } from "ag-grid-community";
import React from "react";
import { FoldableSectionDeprecated } from "../../../components";
import ViewEditTable from "../../../components/ViewEditTable/ViewEditTable";
import { VETEmptyValidator } from "../../../components/ViewEditTable/ViewEditTableValidators";
import { setShowSuccessMessageThunk } from "../../../global/globalSlice";
import { useAppDispatch, useAppSelector } from "../../../hooks";
import { ToastMessagesEnums } from "../../../mc-shared/sharedConstants";
import { setMilestonesInRedux } from "../../actions";
import { doUpdateMilestones } from "./restQueries";

const ProjectMilestoneSettingsPage: React.FC = () => {
  const dispatch = useAppDispatch();
  const project = useAppSelector((state) => state.adminReducer.project);

  const updateMilestones = async (milestones: IMilestone[]) => {
    const _milestones = await doUpdateMilestones(project._id, milestones);
    dispatch(setMilestonesInRedux(_milestones));
    dispatch(setShowSuccessMessageThunk(ToastMessagesEnums.UPDATED));
  };

  const columns: ColDef<IMilestone>[] = [
    {
      field: "name",
      headerName: "Navn",
      editable: true,
    },
    {
      field: "description",
      headerName: "Beskrivelse",
      editable: true,
    },
    {
      field: "dueDate",
      headerName: "Frist",
      editable: true,
      cellDataType: "dateString",
    },
  ];

  const newItemTemplateObject: IMilestone = {
    _id: null,
    name: "",
    description: "",
    dueDate: "",
  };

  return (
    <div className="d-flex flex-column w-100">
      <FoldableSectionDeprecated>
        <FoldableSectionDeprecated.Header>
          <h5 className="mt-2">Milepæler for prosjekt</h5>
        </FoldableSectionDeprecated.Header>
        <FoldableSectionDeprecated.Body>
          <ViewEditTable
            validators={[VETEmptyValidator, VETEmptyValidator]}
            columns={columns}
            data={project.milestones || []}
            onSave={updateMilestones}
            newItemTemplateObject={newItemTemplateObject}
            canEdit={true}
          />
        </FoldableSectionDeprecated.Body>
      </FoldableSectionDeprecated>
    </div>
  );
};

export default ProjectMilestoneSettingsPage;
